import { Textarea, useComputedColorScheme } from '@mantine/core';
import { useActiveForm } from 'pages/claims/components/ClaimFormProvider';
import React from 'react';

interface ModalTextAreaProps {
  label: string;
  required?: boolean;
  accessorKey: string;
  disabled?: boolean;
  placeholder?: string;
  labelFontSize?: number;
  maxLength?: number;
}

export const ModalTextArea: React.FC<ModalTextAreaProps> = ({
  label,
  required = false,
  accessorKey,
  disabled = false,
  placeholder,
  labelFontSize,
  maxLength,
}) => {
  const computedColorScheme = useComputedColorScheme('dark');
  const color = computedColorScheme === 'dark' ? 'white' : 'black';
  const { form, prefix } = useActiveForm();

  const path = prefix ? `${prefix}.${accessorKey}` : accessorKey;

  const inputProps = form.getInputProps(path);

  return (
    <React.Fragment key={accessorKey}>
      <Textarea
        key={form.key(path)}
        label={label}
        inputSize="sm"
        radius={'md'}
        c={color}
        size="md"
        disabled={disabled}
        placeholder={placeholder}
        maxLength={maxLength}
        styles={
          labelFontSize ? { label: { fontSize: labelFontSize } } : undefined
        }
        resize="vertical"
        withAsterisk={required}
        {...inputProps}
      />
    </React.Fragment>
  );
};
